{
  "it": {
    "issue_category": {
      "labels": {
        "backup_category": "Categoria sostitutiva",
        "category_name": "Nome categoria",
        "delete_category": "Eliminare la categoria \"{name}\"?",
        "delete_category_disclaimer": "Tutte le segnalazioni con questa categoria verranno riassegnate alla categoria che selezionerà di seguito.",
        "integration_warning": "È attiva un'integrazione con il modulo Post-vendita sulla piattaforma. Per creare o modificare le categorie, ci contatti.",
        "new_category": "Categoria"
      }
    }
  }
}
